<template>
    <div id="login" class="container">
        <LoginHeader class="text-center"/>
        <div class="row text-center">
            <div class="col-12" v-if="!role">
                <SelectRoles @setUserRole="setRole" :role="role"></SelectRoles>
            </div>
            <div class="col-12" v-if="role && !signingUp">
                <transition name="fade">
                    <div v-if="performingRequest" class="loading">
                        <p>Loading...</p>
                    </div>
                </transition>
                <LoginForm @resetRole="setRole(null)"
                           @goSignUp="showSignUp"
                           @requesting="requesting"/>
            </div>
            <div class="col-12" v-if="role && signingUp">
                <transition name="fade">
                    <div v-if="performingRequest" class="loading">
                        <p>Loading...</p>
                    </div>
                </transition>
                <SignUpForm @resetRole="setRole(null)"
                           @goLogin="showLogin"
                           @requesting="requesting"/>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<style>
    #login {
        background: #06424d;
        min-height: 100%;
        min-width: 100%;
        color: white;
    }
</style>
<script>
import Footer from '../components/Footer.vue';
import LoginHeader from '../components/LoginHeader.vue';
import SelectRoles from '../components/auth/SelectRoles.vue';
import LoginForm from '../components/auth/LoginForm.vue';
import SignUpForm from '../components/auth/SignupForm.vue';

export default {
    data() {
        return {
            role: null,
            signingUp: false,
            performingRequest: false
        };
    },
    methods: {
        setRole(value) {
            this.role = value;
        },
        showSignUp() {
            this.signingUp = true;
        },
        showLogin() {
            this.signingUp = false;
        },
        requesting(val) {
            this.performingRequest = val;
        }
    },
    components: {
        SignUpForm,
        SelectRoles,
        LoginForm,
        LoginHeader,
        Footer
    }
};
</script>
